<div class="twc-typography-headline-2">
  {{ shipment().displayStatus }}
</div>
<twc-shipment-tracking-status
  class="my-20 display-block"
  [checkpoints]="statusCheckpoints()"
></twc-shipment-tracking-status>
<hr class="divider my-0" />
@if (shipment().reference_numbers?.length) {
  <div class="twc-typography-headline-3 mb-16 mt-24">Reference numbers</div>
  <div class="reference-numbers twc-typography-body-1 mb-20">
    @for (refNumber of shipment().reference_numbers; track refNumber.key) {
      {{ refNumber.key }}: {{ refNumber.value }}{{ $last ? '' : ', ' }}
    }
  </div>
  <hr class="divider my-0" />
}
<div class="twc-typography-headline-3 pt-24 mb-16">Shipment progress</div>
<twc-checkpoint-lane
  [data]="shipment().tracking_events"
  [leftTemplate]="leftTemplate"
  [rightTemplate]="rightTemplate"
>
</twc-checkpoint-lane>

<ng-template #leftTemplate let-item>
  <twc-date-string
    fontClass="twc-typography-body-2"
    [showTime]="false"
    [showTimeZone]="false"
    [date]="item.occurred_at"
    [dateFormat]="dateFormat"
    [timeFormat]="timeFormat"
  />
  <br />
  <twc-date-string
    fontClass="twc-typography-body-2"
    [showDate]="false"
    [date]="item.occurred_at"
    [dateFormat]="dateFormat"
    [timeFormat]="timeFormat"
  />
</ng-template>
<ng-template #rightTemplate let-item>
  <div class="twc-typography-body-2">
    {{ item.message }}
  </div>
  <div class="twc-typography-body-2-medium mb-20">
    {{ item.city }}{{ item.city ? ',' : '' }} {{ item.state }}
  </div>
</ng-template>

<ng-template #pickedUpCheckpointDetails>
  @if (shipment().estimated_pickup) {
    <div class="display-flex twc-typography-body-2 gap-2 white-space-nowrap">
      <span class="twc-color-secondary-typeface">Estimated:</span>
      <twc-date-string
        fontClass="twc-typography-body-2"
        colorClass="twc-color-secondary-typeface"
        [date]="shipment().estimated_pickup"
        [dateFormat]="dateFormat"
        [timeFormat]="timeFormat"
      />
    </div>
  }
  @if (shipment().actual_pickup) {
    <div class="display-flex twc-typography-body-2 gap-2 white-space-nowrap">
      <span class="twc-color-secondary-typeface">Actual:</span>
      <twc-date-string
        fontClass="twc-typography-body-2"
        colorClass="twc-color-secondary-typeface"
        [date]="shipment().actual_pickup"
        [dateFormat]="dateFormat"
        [timeFormat]="timeFormat"
      />
    </div>
  }
</ng-template>
<ng-template #deliveredCheckpointDetails>
  @if (shipment().estimated_pickup) {
    <div class="display-flex twc-typography-body-2 gap-2 white-space-nowrap">
      <span class="twc-color-secondary-typeface">Estimated:</span>
      <twc-date-string
        fontClass="twc-typography-body-2"
        colorClass="twc-color-secondary-typeface"
        [date]="shipment().estimated_delivery"
        [dateFormat]="dateFormat"
        [timeFormat]="timeFormat"
      />
    </div>
  }
  @if (shipment().actual_delivery) {
    <div class="display-flex twc-typography-body-2 gap-2 white-space-nowrap">
      <span class="twc-color-secondary-typeface">Actual:</span>
      <twc-date-string
        fontClass="twc-typography-body-2"
        colorClass="twc-color-secondary-typeface"
        [date]="shipment().actual_delivery"
        [dateFormat]="dateFormat"
        [timeFormat]="timeFormat"
      />
    </div>
  }
</ng-template>
